export default __webpack_public_path__ + "static/media/Marvel.1004b8c3.jpg";